// Import Img
import volunteer1 from "../../assets/img/banner/WhatsApp Image 2025-06-16 at 03.25.39_f30d435a.jpg";
import volunteer2 from "../../assets/img/banner/WhatsApp Image 2025-06-16 at 03.44.06_b818816e.jpg";
import volunteer3 from "../../assets/img/banner/WhatsApp Image 2025-06-16 at 03.45.32_945ba7b7.jpg";
import volunteer4 from "../../assets/img/banner/WhatsApp Image 2025-06-16 at 04.14.35_b0497ff2.jpg";
import volunteer5 from "../../assets/img/banner/WhatsApp Image 2025-06-16 at 05.46.00_f72218cc.jpg";
import volunteer6 from "../../assets/img/banner/WhatsApp Image 2025-06-17 at 01.24.16_3acc7d1e.jpg";
import volunteer7 from "../../assets/img/banner/IMG-20250531-WA0007.jpg";
import volunteer8 from "../../assets/img/banner/WhatsApp Image 2026-03-03 at 10.30.37 PM.jpeg";
import volunteer9 from "../../assets/img/banner/WhatsApp Image 2026-06-25 at 9.57.01 AM.jpeg";
import volunteer10 from "../../assets/img/banner/WhatsApp Image 2026-06-25 at 9.57.01 AM(1).jpeg";

export const TeamDatas = [
  {
    img: volunteer6,
    name: "Samantha Erhabor",
    title: "Founder and Executive Director",
  },
  {
    img: volunteer1,
    name: "Grace Bello",
    title: "Founding Member / Strategic Advisor",
  },
  {
    img: volunteer4,
    name: "Amenze Iyamu",
    title: "Medical Advisor",
  },
  {
    img: volunteer2,
    name: "Rose Benjamin-Kadiri",
    title: "Lead Facilitator, Maternal Support Program",
  },
  //   {
  //     img: volunteer3,
  //     name: "Henrietta Elaiho",
  //     title: "",
  //   },
  {
    img: volunteer5,
    name: "Jeanette Iyamu",
    title: "Partnership Director",
  },
  {
    img: volunteer8,
    name: "Freda W Ehiorobo",
    title: "Program Coordinator",
  },
  {
    img: volunteer9,
    name: "Naomi Nosakhare",
    title: "Hope and Care Advocate",
  },
  {
    img: volunteer10,
    name: "Henrietta Elaiho",
    title: "Stewardship Lead",
  },
];
